import { Modal } from "react-bootstrap";
import { useAddonLogByDate } from "../../../utils/addons/AddonUtils";
import moment from "moment";

export default function ModalDetailLogAddons({ show, date, onClose }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Detail Log Add-ons</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CubmuLogByDate date={date} />
      </Modal.Body>
    </Modal>
  );
}

function CubmuLogByDate({ date }) {
  const { logsByDate, loading } = useAddonLogByDate({ date });
  return (
    <div style={{ opacity: loading ? "0.5" : 1, overflowX: "auto" }}>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Nama Customer</th>
            <th>Akun</th>
            <th>Addon</th>
            <th>Paket</th>
            <th>Tgl. Akses</th>
            <th>Log</th>
          </tr>
        </thead>
        <tbody>
          {logsByDate.length === 0 && (
            <tr>
              <td colSpan={6} className="text-center">
                Tidak ada data
              </td>
            </tr>
          )}
          {logsByDate.map((log_date, index) => (
            <tr key={index}>
              <td className="text-nowrap">{log_date.addon.customer.name}</td>
              <td className="text-nowrap">{log_date.addon.account_email}</td>
              <td className="text-nowrap">{log_date.addon.addon_name}</td>
              <td className="text-nowrap">{log_date.addon.product_name}</td>
              <td className="text-nowrap">
                {moment.unix(log_date.created_at).format("DD MMM YYYY - HH:mm")}
              </td>
              <td>
                <div className="" style={{ maxHeight: "100px", width: "400px", overflow: "auto" }}>
                  {log_date.send_log_response}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
